export default "__VITE_ASSET__BUZwoca5__"